import { useEffect, useState } from "react";
import styled from "styled-components";

import { FluidAccent } from "~/src/modules/ui-kit";

import ParameterValue from "./ParameterValue";
import useParameter from "../Parameter/useParameter";


export const Component = styled(ParameterValue)`
    ${ FluidAccent }
`;

export function getID(entity) {
    return entity.id;
}

export const name = "ParameterValue";

export function useSearch(token: string, options) {
    const parameter = useParameter(options.parameterID);

    const [results, setResults] = useState(undefined);

    useEffect(
        () => {
            if (parameter.data) {
                setResults(
                    parameter.data.parameter.values.filter(
                        (value) => {
                            if (!token) return true;
                            return [
                                value.id.replaceAll("-", "").toLowerCase().includes(token.replaceAll("-", "").toLowerCase()),
                                value.label.map(
                                    (localization) => localization.text
                                ).some(
                                    (text) => text.toLowerCase().includes(token.toLowerCase())
                                ),
                            ].some(Boolean);
                        }
                    )
                );
            } else {
                setResults([]);
            }
        },
        [parameter.data, token],
    );

    return {
        error: parameter.error,
        loading: parameter.loading,
        results,
    };
}
